import React from 'react';
import { Animation } from '@forecast-it/design-system';
import styled from 'styled-components';
import { hasFeatureFlag } from '../../util/FeatureUtil';
import { hasModule } from '../../util/ModuleUtil';
import { MODULE_TYPES } from '../../../../constants';
const SpinnerWrapper = styled.div `
	display: flex;
	justify-content: center;
	align-items: center;
`;
const AnimationWrapper = styled.div `
	width: 24px;
	height: 24px;
`;
function canSpin() {
    return hasFeatureFlag('use_sage_service_for_time_regs') && hasModule(MODULE_TYPES.SAGE_INTACCT_RESTRICTED);
}
const Spinner = ({ children, spinning }) => {
    return (React.createElement(SpinnerWrapper, null, spinning && canSpin() ? (React.createElement(AnimationWrapper, null,
        React.createElement(Animation, { animation: 'loaderWhite' }))) : (children)));
};
export default Spinner;
